import React from "react"
import Back from "../common/back/Back"
import CoursesCard from "./CoursesCard"
import OnlineCourses from "./OnlineCourses"
import Heading from "../common/heading/Heading"
import "./courses.css"

const CourseHome = () => {
  return (
    <>
      <Back />
      <section className="padding">
        <div className="container shadow aboutUs">
          <h1>Course Details</h1>
          <div className="vision-container">
            
            <p className="courseDetails">
              <strong>செம்மொழிக் கல்விக்கூடம் (Chemmozhi Academy) </strong>
              நடத்தும்
               <br />
              <strong>தமிழாசிரியர்ப் பயிற்சி (Tamil Teachers’ Training)</strong> <br /> <br />
              <strong>ஒருமாதகாலச் சான்றிதழ்ப் படிப்பு (One-month Certificate Course)</strong> <br /> <br />
              <strong>தேதிகள்:</strong> மே 23 முதல் ஜூன் 14, 2026 வரை <br />
              ஒவ்வொரு வாரமும் சனி, ஞாயிற்றுக்கிழமைகளில்
              பிற்பகல் 2 முதல் 6 மணி வரை
              மொத்தம் 4 வாரங்கள் / 8 நாட்கள்*4 / 32 மணி நேரம் <br /> 

              <strong>பயிற்சிக் கட்டணம்:</strong> $300  <br/>
              <strong>கல்வித்தகுதி:</strong> 12th / GCE (A/L) <br />

              <strong>பதிவு செய்ய:</strong> <a href="https://forms.gle/8VDquZw969Arwxj77" target="_blank" rel="noopener noreferrer">Click Here to Register</a> <br /> <br />

              <strong>பயிற்றுநர்கள்</strong>  <br />
              <i>பேராசிரியர் இல. சுந்தரம்</i> <br />
              <i>முனைவர் செல்வநாயகி ஸ்ரீதாஸ்</i> <br /> <br />

              <strong>பயனாளர்கள்</strong> <br />
              கனடாவில் தமிழாசிரியராகப் பணிசெய்ய விரும்புவோருக்கும் பணிசெய்வோருக்குமான
              புதிய கற்பித்தல் அணுகுமுறைகளைக் கொண்ட பயிலரங்கு <br /> <br />

              <strong>வகுப்புகள் நடைபெறும் இடம்</strong> <br /> Amana Conference Hall, 2855 Markham Rd, Suite 302, Scarborough ON M1X 0C3. <br /><br />

              <strong>மேலும் விவரங்களுக்கு</strong> <br />
              <i>பேராசிரியர் இல. சுந்தரம்</i> <br />
              (437) 979-3006 <br />
              <i>முனைவர் செல்வநாயகி ஸ்ரீதாஸ்</i> <br />
              (647) 881-3613 <br />

              <a href="mailto:info@chemmozhi.ca">info@chemmozhi.ca</a> <br />
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

export default CourseHome
